import React, { useEffect, useState, Component } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Handle hash scrolling when navigating from another page
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    } else if (!location.hash && isHomePage) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location, isHomePage]);
  const navLinks = [{
    name: 'Domů',
    href: '#hero'
  }, {
    name: 'Služby',
    href: '#services'
  }, {
    name: 'Akce',
    href: '#events'
  }, {
    name: 'Pro piloty',
    href: '#pilot-info'
  }, {
    name: 'Briefing',
    href: '/briefing',
    highlight: true,
    isRoute: true
  }, {
    name: 'Kontakt',
    href: '#contact'
  }];
  const getLinkProps = (link: (typeof navLinks)[0]) => {
    if (link.isRoute) {
      return {
        to: link.href,
        as: Link
      };
    }
    // If on homepage, use simple anchor for smooth scroll
    if (isHomePage) {
      return {
        href: link.href,
        as: 'a'
      };
    }
    // If on other page, link to homepage with hash
    return {
      to: `/${link.href}`,
      as: Link
    };
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-[#0a1628]/90 backdrop-blur-md border-b border-white/10' : 'bg-transparent'}`} data-id="element-176">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-177">
        <div className="flex items-center justify-between h-20" data-id="element-178">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold tracking-tighter text-white group" data-id="element-179">
            LKHV
            <span className="text-[#38bdf8] group-hover:text-[#60a5fa] transition-colors" data-id="element-180">
              .<span className="text-lg font-semibold" data-id="element-181">eu</span>
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-182">
            {navLinks.map(link => {
            const {
              as: Component,
              ...props
            } = getLinkProps(link);
            return (
              // @ts-ignore - Dynamic component props
              <Component key={link.name} {...props} className={`text-sm font-medium transition-colors ${link.highlight ? 'text-[#38bdf8] hover:text-[#60a5fa]' : 'text-white/80 hover:text-[#38bdf8]'}`} data-id="element-183">
                  {link.name}
                </Component>
            );
          })}
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white hover:text-[#38bdf8] transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-184">
            {isMobileMenuOpen ? <X size={24} data-id="element-185" /> : <Menu size={24} data-id="element-186" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-187">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#0a1628] border-b border-white/10 overflow-hidden" data-id="element-188">
            <div className="px-6 py-8 flex flex-col space-y-4" data-id="element-189">
              {navLinks.map(link => {
            const {
              as: Component,
              ...props
            } = getLinkProps(link);
            return (
              // @ts-ignore - Dynamic component props
              <Component key={link.name} {...props} className={`text-lg font-medium transition-colors ${link.highlight ? 'text-[#38bdf8] hover:text-[#60a5fa]' : 'text-white/80 hover:text-[#38bdf8]'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-190">
                    {link.name}
                  </Component>
            );
          })}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}